import React, { useState, useEffect } from "react";
import { useParams } from 'react-router';
import Parser from 'html-react-parser';
import contentServiceApi from "../../service/contentService";
import { useTranslation } from "react-i18next";

import "./pagecontent.css";
export default function PageContent()
{
  const { slug } = useParams();
  const [contentData, setContentData] = useState(null);
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true; 
    if (!slug) return;
    
    setContentData(null); 
    setLoading(true);

    contentServiceApi.getBySlug(slug).then((response) => {
      setContentData(response.data);
    }).catch((error) => {
      setContentData(null); 
    })
    .finally(() => {
      setLoading(false);
    });
    return () => {
      isMounted = false; 
    };
  }, [slug]);

  if (loading) return <div>Đang tải nội dung...</div>;

  return (
    <div className="page-content">
      <div className="container">
        <div className="page-content-inner">
          <a href="/" className="back-homepage"><i className="fa fa-arrow-left"></i> {t("content.backHomePage")}</a>
          <h3 className="page-content-title">{contentData && contentData.title}</h3>
          <div className="page-content-content">{contentData && Parser(contentData.content)}</div>
        </div>
      </div>
    </div>
  );
}
